import fetch from './communityFetch';

const getCategory = params => fetch({ url: '/category/get_list', params });
const addCategory = ({ params }) => fetch({ url: '/category', params, methold: 'post' });
const editCategory = ({ params, category_id }) => fetch({ url: `/category/${category_id}`, params, methold: 'put' });
const categoryBatchDelete = ({ params }) => fetch({ url: '/category/batch_delete', params, methold: 'delete' });
const categoryBatchActive = ({ params }) => fetch({ url: '/category/batch_activate', params, methold: 'post' });
const categoryBatchDeactivate = ({ params }) => fetch({ url: '/category/batch_deactivate', params, methold: 'post' });

export default {
  getCategory,
  addCategory,
  editCategory,
  categoryBatchDelete,
  categoryBatchActive,
  categoryBatchDeactivate
};
